import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Stepper } from "@shared/components/Stepper";
import { ConnectionStep } from "@features/ix/shared/ConnectionStep";
import { SyncFlowsStep } from "./stepComponents/syncFlow/syncFlow";
import { ReviewStep } from "./stepComponents/review/review";
import { Button } from "@shared/ui/button";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@shared/components/PageHeader";
import { useNavigate } from "react-router-dom";

export const CreateNeptuneIntegration: React.FC = () => {
  const storageKey = "neptune-integration-progress";
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!id) {
      localStorage.removeItem("neptune-integration-progress");
      if (window.location.hash) {
        window.location.hash = "";
      }
    }
  }, [id]);

  React.useEffect(() => {
    return () => {
      localStorage.removeItem("neptune-integration-progress");
    };
  }, []);

  const steps = useMemo(
    () => [
      {
        title: "Connection",
        slug: "connection",
        description: "Credentials & verify",
        component: (
          <ConnectionStep
            integrationKey="neptune"
            title="Neptune"
            defaultIntegrationName="Neptune — Production"
            defaultApiBaseUrl="https://api.neptunetg.com/v1"
            defaultAuthType={1}
            defaultApiKey="nep_prod_1234567890"
            envInfoText="Neptune connects directly to your sandbox tenant. Changes affect live data."
            testPingUrl="https://api.neptunetg.com/v1/ping"
          />
        ),
        optional: false,
      },
      {
        title: "Sync Flows",
        slug: "sync-flows",
        description: "What & how to sync",
        component: <SyncFlowsStep />,
        optional: false,
      },
      {
        title: "Review",
        slug: "review",
        description: "Activate integration",
        component: <ReviewStep />,
        optional: false,
      },
    ],
    [],
  );

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between pb-4">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              localStorage.removeItem(storageKey);
              navigate("/integration-hub/smart-meter-oem");
            }}
          >
            <ArrowLeft size={16} />
          </Button>
          <PageHeader
            title="Connect Neptune Smart Meter OEM"
            subtitle="Configure a new connector instance for synchronization, meter reads, and data flows."
          />
        </div>
      </div>

      <Stepper
        steps={steps}
        onStepChange={() => {}}
        onStepSave={async () => {}}
        enableApiSave={false}
        saveOnStepChange={false}
        trackDirtyState={false}
        autoSave={true}
        persistProgress={true}
        allowSkip={false}
        storageKey={storageKey}
        enableRouting={true}
        onComplete={() => {}}
        onValidation={undefined}
        showDraftResume={true}
        allowStepClick={!!id}
        initialCompletedSteps={!!id ? [0, 1, 2] : []}
      />
    </div>
  );
};

export default CreateNeptuneIntegration;
